const translations = {
  en: {
    // Brand & Nav
    brandName: 'Synicate Technologies',
    publicDesk: 'Public Complaint Desk',
    trackTicket: 'Track Ticket',
    dashboard: 'Dashboard',
    staffUsers: 'Staff & Users',
    departments: 'Departments',
    areaMaster: 'Area Master',
    signIn: 'Sign In',
    registerAccount: 'Register Account',
    logout: 'Logout',
    english: 'English',
    marathi: 'मराठी',

    // Statuses
    status_Submitted: 'Submitted',
    status_Assigned: 'Assigned',
    status_InProgress: 'In Progress',
    status_PendingCustomer: 'Pending Customer',
    status_Resolved: 'Resolved',
    status_Closed: 'Closed',
    status_Escalated: 'Escalated',

    // Priorities
    priority_Low: 'Low',
    priority_Medium: 'Medium',
    priority_High: 'High',
    priority_Urgent: 'Urgent',

    // Public Complaint Page
    publicCitizenDesk: 'Public Citizen Desk',
    registerPublicComplaint: 'Register Public Complaint',
    publicDeskSubtitle: 'No account or signup required. Submit your issue below and receive an instant tracking ticket number.',
    stepContactDetails: 'Contact Details',
    stepWardLocation: 'Ward & Location',
    stepIssueDescription: 'Issue Description',
    registeredWard: 'Registered Ward',
    electedWardOfficials: 'Elected Ward Officials',
    noWardOfficials: 'No specific ward officials assigned yet.',
    citizenContactInfo: '1. Citizen Contact Info',
    fullName: 'Your Full Name',
    mobilePhone: 'Mobile Phone Number',
    emailAddress: 'Email Address',
    locationComplaintInfo: '2. Location & Complaint Information',
    selectAreaWard: 'Area / Ward Master',
    chooseAreaWard: '-- Select Public Ward / Area --',
    subAreaLocation: 'Sub-Area / Specific Location',
    chooseSubArea: '-- Select Specific Sub-Location --',
    selectAreaFirst: '-- Select Area First --',
    noSubAreasDefined: 'No Sub-Areas defined for this Ward',
    targetDepartment: 'Target Department',
    chooseDepartment: '-- Select Department --',
    category: 'Category',
    priorityLevel: 'Priority Level',
    complaintSubject: 'Complaint Subject / Title',
    subjectPlaceholder: 'Brief summary of the issue',
    detailedDescription: 'Detailed Description',
    descriptionPlaceholder: 'Describe the complaint in detail, location landmarks, etc.',
    attachComplaintPhoto: 'Attach Complaint Photo ("Before" Image)',
    photoHelpText: 'Attach a photo showing the issue (Optional, up to 10MB).',
    submitTicket: 'Submit Complaint Ticket',
    submittingTicket: 'Submitting Public Complaint...',
    complaintSubmittedSuccess: 'Complaint Submitted Successfully!',
    complaintLoggedNotice: 'Your complaint has been logged and assigned an instant ticket number:',
    officialTicketRef: 'Official Ticket Reference',
    copyTicketNumber: 'Copy Ticket Number',
    ticketCopiedAlert: 'Ticket number copied to clipboard!',
    saveTicketNotice: 'Please save your Ticket Number! You can use it anytime on our Track Ticket desk without logging in.',
    trackTicketStatusNow: 'Track Ticket Status Now',
    registerAnotherComplaint: 'Register Another Complaint',

    // Categories
    cat_General: 'General Query / Issue',
    cat_Infrastructure: 'Infrastructure & Road Maintenance',
    cat_WaterSanitation: 'Water Supply & Cleanliness',
    cat_Electricity: 'Electrical & Streetlights',
    cat_Billing: 'Billing & Administrative',
    cat_TechnicalIssue: 'Technical Issue',
    cat_BillingRefund: 'Billing & Refund',
    cat_ServiceInterruption: 'Service Interruption',
    cat_InfrastructureDefect: 'Infrastructure Defect',
    cat_RoadDrainage: 'Road & Drainage Defect',
    cat_Other: 'Other Issues',

    // Track Complaint Page
    trackComplaintStatus: 'Track Complaint Status',
    trackSubtitle: 'Enter your Ticket Reference Number to check real-time status and staff comments.',
    trackTicketPlaceholder: 'e.g. CMP-2026-1234',
    trackStatusBtn: 'Track Status',
    ticketRef: 'Complaint Ticket Reference',
    submittedBy: 'Submitted By',
    targetSLADue: 'Target SLA Due',
    publicStatusUpdates: 'Public Status Updates & Comments',
    noPublicUpdates: 'No public updates added by staff yet.',
    auditTrailLog: 'Audit Trail Activity Log',
    noAuditLog: 'No log history recorded.',
    registerNewComplaint: 'Register New Complaint',

    // Before & After Report
    beforeAfterTitle: 'Before & After Visual Report',
    beforeAfterSubtitle: 'Compare initial issue photo submitted by customer with solution photo attached by staff.',
    printOfficialReport: 'Print Official Report',
    officialReportHeader: 'OFFICIAL COMPLAINT & RESOLUTION REPORT',
    publicWorksDesk: 'Public Works & Municipal Governance Desk',
    dateGenerated: 'Date Generated',
    beforeIssue: 'BEFORE (Issue)',
    afterSolution: 'AFTER (Solution)',
    verifiedFixed: 'Verified Fixed',
    customerDescription: 'Customer Description:',
    agentResolutionRemarks: 'Agent Resolution Remarks:',
    noBeforePhoto: 'No initial photo uploaded by customer.',
    noAfterPhoto: 'No resolution photo attached.',
    pendingResolutionPhoto: 'Pending staff resolution photo.',
    noResolutionNotes: 'No resolution notes provided yet.',
    authorizedSignoff: 'Authorized Sign-off / Officer Signature',

    // Customer Dashboard
    customerPortal: 'Customer Portal',
    trackSubmitComplaints: 'Track & Submit Complaints',
    customerPortalDesc: 'Submit support tickets, view live SLA resolution timers, and communicate directly with assigned support personnel.',
    submitNewComplaint: 'Submit New Complaint',
    totalTickets: 'Total Tickets',
    inProgress: 'In Progress',
    resolved: 'Resolved',
    escalated: 'Escalated',
    myComplaints: 'My Complaint Requests',
    allStatuses: 'All Statuses',
    allAreas: 'All Areas',
    allDepartments: 'All Departments',
    loadingTickets: 'Loading your tickets...',
    noComplaintsFound: 'No complaints found',
    clickSubmitHint: 'Click "Submit New Complaint" to create a support ticket.',
    tableTicketNum: 'Ticket #',
    tableTitleCat: 'Title & Category',
    tableAreaLoc: 'Area & Location',
    tableDept: 'Department',
    tablePriority: 'Priority',
    tableStatus: 'Status',
    tableAction: 'Action',
    tableCustomer: 'Customer',
    tableAssignedEmp: 'Assigned Employee',
    tableManage: 'Manage',
    viewDetails: 'View Details',
    notSpecified: 'Not Specified',
    unassigned: 'Unassigned',
    cancel: 'Cancel',
    autoAssignDefault: 'Auto-Assign (Default)',

    // Staff Dashboard
    staffCommandCenter: 'Staff Command Center',
    deptHeadDesk: 'Department Head Command Desk',
    employeeDesk: 'My Assigned Complaints Desk',
    repDesk: 'Elected Representative Ward Desk',
    role: 'Role',
    ward: 'Ward',
    resetFilters: 'Reset Filters',
    edit: 'Edit',
    manageTicket: 'Manage Ticket',
    updateStatus: 'Update Status',
    assignDeptEmployee: 'Assign Department Employee',
    noEmpAssigned: 'No Employee Assigned',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    resolutionRemarksSummary: 'Resolution Remarks / Fix Summary',
    resolutionPlaceholder: 'Describe how the issue was fixed, work done, staff notes...',
    attachSolutionPhoto: 'Attach Solution Photo ("After" Image)',

    // Complaint Detail Page
    backToDashboard: 'Back to Dashboard',
    escalationNotice: 'MANAGEMENT ESCALATION NOTICE',
    escalationDesc: 'This ticket has been escalated due to SLA policy or high customer urgency.',
    commentsUpdates: 'Comments & Updates',
    noCommentsYet: 'No comments yet. Start the conversation below.',
    addResponseRemark: 'Add Response / Remark',
    typeReplyHere: 'Type your reply here...',
    makeInternalNote: 'Make Internal Note (Hidden from Customer)',
    postComment: 'Post Comment',
    posting: 'Posting...',
    staffInternalNote: 'Staff Internal Note',
    staffSolutionDesk: 'Staff Solution & Resolution Desk',
    saveAttachSolution: 'Save & Attach Solution Photo',
    savingResolution: 'Saving Resolution...',
    areaWardOfficials: 'Area & Ward Officials',
    ticketAssignment: 'Ticket Assignment',
    assignedDept: 'Assigned Department',
    assignedAgent: 'Assigned Agent',
    slaTargetResolution: 'SLA Target Resolution',
    slaBreached: 'SLA Breached!',
    requestEscalation: 'Request Escalation',
    auditHistoryTrail: 'Audit History Trail',

    // Auth
    welcomeBack: 'Welcome Back',
    signInSubtitle: 'Sign in to access your complaint management dashboard.',
    emailLabel: 'Email Address',
    passwordLabel: 'Password',
    loginBtn: 'Sign In to Account',
    loggingIn: 'Signing in...',
    dontHaveAccount: "Don't have an account?",
    registerNow: 'Register Now',
    createAccount: 'Create Account',
    registerSubtitle: 'Join our civic service desk to easily submit and monitor complaints.',
    fullNameLabel: 'Full Name',
    confirmPasswordLabel: 'Confirm Password',
    registerBtn: 'Create Customer Account',
    registering: 'Creating Account...',
    alreadyHaveAccount: 'Already have an account?',
    signInHere: 'Sign In Here',

    // Footer
    footerRights: 'All Rights Reserved. Public Grievance & Complaint Redressal System.',
    emergencyHelpline: 'Citizen Emergency Helpline: 1800-11-2233',

    // Roles Master
    role_admin: 'System Administrator',
    role_dept_head: 'Department Head',
    role_employee: 'Department Employee',
    role_agent: 'Support Agent',
    role_manager: 'Operations Manager',
    role_representative: 'Ward Representative',
    role_customer: 'Citizen / Customer',
    rolesMaster: 'System Roles Master',
    allRoles: 'All System Roles',
    totalUsersCount: 'Total Users',
    
    // User Management & Edits
    createUserTitle: 'Create Staff / User Login',
    editUserTitle: 'Edit Staff / User Account',
    updateUserBtn: 'Update User Account',
    updatingUser: 'Updating User...',
    leaveBlankPassword: 'Leave blank to keep current password',
    newPasswordOptional: 'New Password (Optional)',
    
    // Area / Location Edits
    createAreaTitle: 'Create Area / Ward Master',
    editAreaTitle: 'Edit Area / Ward Master',
    updateAreaBtn: 'Update Area Record',
    areaName: 'Area / Ward Name',
    areaCode: 'Area / Ward Code',
    
    // Sublocation Edits
    subLocationsMaster: 'Sub-Areas / Sublocations',
    createSubAreaTitle: 'Add Sub-Area / Sublocation',
    editSubAreaTitle: 'Edit Sub-Area / Sublocation',
    updateSubAreaBtn: 'Update Sublocation',
    subAreaNameLabel: 'Sub-Area Name',
    subAreaCodeLabel: 'Sub-Area Code (Optional)',
    
    // Official / Representative Edits
    wardOfficialsTitle: 'Elected Ward Officials',
    addOfficialTitle: 'Add Ward Official',
    editOfficialTitle: 'Edit Ward Official',
    updateOfficialBtn: 'Update Official',
    officialName: 'Official Full Name',
    officialDesignation: 'Designation / Title',
    officialPhone: 'Phone / Contact Number',
    officialEmail: 'Email Address (Optional)',
    
    // Department Edits
    createDepartmentTitle: 'Add Department',
    editDepartmentTitle: 'Edit Department',
    updateDepartmentBtn: 'Update Department',
    departmentName: 'Department Name',
    departmentCode: 'Department Code',
    
    // Common Actions
    actions: 'Actions',
    deleteConfirm: 'Are you sure you want to delete this item?'
  },

  mr: {
    // Brand & Nav
    brandName: 'सिनिकेट टेक्नॉलॉजीज',
    publicDesk: 'सार्वजनिक तक्रार कक्ष',
    trackTicket: 'तक्रार स्थिती तपासा',
    dashboard: 'डॅशबोर्ड',
    staffUsers: 'कर्मचारी व वापरकर्ते',
    departments: 'विभाग',
    areaMaster: 'प्रभाग / क्षेत्र व्यवस्थापन',
    signIn: 'लॉगिन करा',
    registerAccount: 'नवीन खाते तयार करा',
    logout: 'लॉगआउट',
    english: 'English',
    marathi: 'मराठी',

    // Statuses
    status_Submitted: 'नोंदवले',
    status_Assigned: 'नियुक्त केले',
    status_InProgress: 'प्रगतीपथावर',
    status_PendingCustomer: 'ग्राहक प्रतिसाद प्रलंबित',
    status_Resolved: 'निराकरण झाले',
    status_Closed: 'बंद केले',
    status_Escalated: 'उच्च स्तरावर वर्ग केले',

    // Priorities
    priority_Low: 'कमी',
    priority_Medium: 'मध्यम',
    priority_High: 'उच्च',
    priority_Urgent: 'तातडीचे',

    // Public Complaint Page
    publicCitizenDesk: 'सार्वजनिक नागरिक सेवा केंद्र',
    registerPublicComplaint: 'सार्वजनिक तक्रार नोंदवा',
    publicDeskSubtitle: 'कोणत्याही लॉगिन किंवा खात्याची गरज नाही. खाली आपली तक्रार नोंदवा आणि तात्काळ ट्रॅकिंग तिकीट क्रमांक मिळवा.',
    stepContactDetails: 'संपर्क माहिती',
    stepWardLocation: 'प्रभाग व ठिकाण',
    stepIssueDescription: 'तक्रारीचा तपशील',
    registeredWard: 'नोंदणीकृत प्रभाग',
    electedWardOfficials: 'निवडून आलेले प्रभाग प्रतिनिधी',
    noWardOfficials: 'अद्याप कोणतेही प्रभाग प्रतिनिधी नियुक्त नाहीत.',
    citizenContactInfo: '१. नागरिकांची संपर्क माहिती',
    fullName: 'आपले पूर्ण नाव',
    mobilePhone: 'मोबाईल फोन नंबर',
    emailAddress: 'ईमेल पत्ता',
    locationComplaintInfo: '२. प्रभाग, ठिकाण व तक्रारीची माहिती',
    selectAreaWard: 'प्रभाग / क्षेत्र निवडा',
    chooseAreaWard: '-- प्रभाग / क्षेत्र निवडा --',
    subAreaLocation: 'उपनगर / विशिष्ट ठिकाण',
    chooseSubArea: '-- विशिष्ट उप-ठिकाण निवडा --',
    selectAreaFirst: '-- आधी प्रभाग निवडा --',
    noSubAreasDefined: 'या प्रभागासाठी उप-ठिकाणे उपलब्ध नाहीत',
    targetDepartment: 'संबंधित विभाग',
    chooseDepartment: '-- संबंधित विभाग निवडा --',
    category: 'तक्रार वर्गवारी / प्रकार',
    priorityLevel: 'प्राधान्यता पातळी',
    complaintSubject: 'तक्रारीचा विषय / शीर्षक',
    subjectPlaceholder: 'समस्येचा संक्षिप्त विषय प्रविष्ट करा',
    detailedDescription: 'तक्रारीचे सविस्तर वर्णन',
    descriptionPlaceholder: 'समस्येचा सविस्तर तपशील, परिसराची खूण इत्यादी येथे लिहा...',
    attachComplaintPhoto: 'तक्रारीचा फोटो जोडा ("आधीचा" फोटो)',
    photoHelpText: 'समस्येचा स्पष्ट फोटो जोडा (पर्यायी, कमाल १०MB).',
    submitTicket: 'तक्रार तिकीट सादर करा',
    submittingTicket: 'तक्रार नोंदवत आहे...',
    complaintSubmittedSuccess: 'तक्रार यशस्वीरित्या नोंदवली गेली!',
    complaintLoggedNotice: 'आपली तक्रार नोंदवली गेली असून तात्काळ तिकीट क्रमांक जारी करण्यात आला आहे:',
    officialTicketRef: 'अधिकृत तिकीट क्रमांक',
    copyTicketNumber: 'तिकीट क्रमांक कॉपी करा',
    ticketCopiedAlert: 'तिकीट क्रमांक कॉपी झाला!',
    saveTicketNotice: 'कृपया आपला तिकीट क्रमांक जतन करून ठेवा! आपण लॉगिन न करता कधीही तक्रार स्थिती तपासू शकता.',
    trackTicketStatusNow: 'तक्रारीची सद्यस्थिती तपासा',
    registerAnotherComplaint: 'दुसरी तक्रार नोंदवा',

    // Categories
    cat_General: 'सामान्य चौकशी / समस्या',
    cat_Infrastructure: 'पायाभूत सुविधा व रस्ते दुरुस्ती',
    cat_WaterSanitation: 'पाणीपुरवठा व स्वच्छता',
    cat_Electricity: 'विद्युत व पथदिवे',
    cat_Billing: 'बिलिंग व प्रशासकीय',
    cat_TechnicalIssue: 'तांत्रिक समस्या',
    cat_BillingRefund: 'बिलिंग व परतावा',
    cat_ServiceInterruption: 'सेवा खंडित',
    cat_InfrastructureDefect: 'पायाभूत सुविधा दोष',
    cat_RoadDrainage: 'रस्ते व सांडपाणी समस्या',
    cat_Other: 'इतर समस्या',

    // Track Complaint Page
    trackComplaintStatus: 'तक्रारीची सद्यस्थिती तपासा',
    trackSubtitle: 'रिअल-टाइम स्थिती आणि कर्मचाऱ्यांच्या टिप्पण्या पाहण्यासाठी आपला तिकीट क्रमांक प्रविष्ट करा.',
    trackTicketPlaceholder: 'उदा. CMP-2026-1234',
    trackStatusBtn: 'स्थिती तपासा',
    ticketRef: 'तक्रार तिकीट संदर्भ',
    submittedBy: 'तक्रारदार',
    targetSLADue: 'निवारणाची अंतिम मुदत',
    publicStatusUpdates: 'सार्वजनिक अद्यतने व टिप्पण्या',
    noPublicUpdates: 'कर्मचाऱ्यांकडून अद्याप कोणतीही सार्वजनिक टिप्पणी जोडलेली नाही.',
    auditTrailLog: 'ऑडिट ट्रेल कार्य नोंद',
    noAuditLog: 'कोणतीही नोंद उपलब्ध नाही.',
    registerNewComplaint: 'नवीन तक्रार नोंदवा',

    // Before & After Report
    beforeAfterTitle: 'कामाचा प्रत्यक्ष पुरावा अहवाल (आधी आणि नंतर)',
    beforeAfterSubtitle: 'नागरिकाने पाठवलेला समस्येचा आधीचा फोटो आणि कर्मचाऱ्यांनी केलेल्या कामाचा नंतरचा फोटो यांची तुलना.',
    printOfficialReport: 'अधिकृत अहवाल प्रिंट करा',
    officialReportHeader: 'अधिकृत तक्रार निवारण व कार्य अहवाल',
    publicWorksDesk: 'सार्वजनिक बांधकाम व महानगरपालिका प्रशासन विभाग',
    dateGenerated: 'अहवाल तारीख',
    beforeIssue: 'आधी (समस्या)',
    afterSolution: 'नंतर (निवारण)',
    verifiedFixed: 'काम पूर्ण झाले',
    customerDescription: 'तक्रारदाराचे वर्णन:',
    agentResolutionRemarks: 'कर्मचाऱ्याचा निवारण शेरा / केलेले काम:',
    noBeforePhoto: 'तक्रारदाराने आधीचा फोटो जोडलेला नाही.',
    noAfterPhoto: 'निवारणाचा फोटो जोडलेला नाही.',
    pendingResolutionPhoto: 'कर्मचाऱ्यांचा निवारण फोटो प्रलंबित आहे.',
    noResolutionNotes: 'अद्याप कोणताही निवारण शेरा दिलेला नाही.',
    authorizedSignoff: 'अधिकृत स्वाक्षरी / सक्षम अधिकारी',

    // Customer Dashboard
    customerPortal: 'नागरिक / ग्राहक कक्ष',
    trackSubmitComplaints: 'तक्रारी नोंदवा व स्थिती तपासा',
    customerPortalDesc: 'नवीन तक्रारी नोंदवा, थेट निवारण मुदत पहा आणि नियुक्त कर्मचाऱ्यांशी थेट संपर्क साधा.',
    submitNewComplaint: 'नवीन तक्रार नोंदवा',
    totalTickets: 'एकूण तक्रारी',
    inProgress: 'प्रगतीपथावर',
    resolved: 'निवारण झाले',
    escalated: 'वर्ग केलेल्या',
    myComplaints: 'माझ्या तक्रारींची यादी',
    allStatuses: 'सर्व स्थिती',
    allAreas: 'सर्व प्रभाग',
    allDepartments: 'सर्व विभाग',
    loadingTickets: 'तक्रारी लोड होत आहेत...',
    noComplaintsFound: 'कोणतीही तक्रार आढळली नाही',
    clickSubmitHint: 'नवीन तक्रार दाखल करण्यासाठी "नवीन तक्रार नोंदवा" वर क्लिक करा.',
    tableTicketNum: 'तिकीट #',
    tableTitleCat: 'शीर्षक व वर्गवारी',
    tableAreaLoc: 'प्रभाग व ठिकाण',
    tableDept: 'विभाग',
    tablePriority: 'प्राधान्यता',
    tableStatus: 'स्थिती',
    tableAction: 'कृती',
    tableCustomer: 'तक्रारदार',
    tableAssignedEmp: 'नियुक्त कर्मचारी',
    tableManage: 'व्यवस्थापित करा',
    viewDetails: 'तपशील पहा',
    notSpecified: 'अनिर्दिष्ट',
    unassigned: 'अनियुक्त',
    cancel: 'रद्द करा',
    autoAssignDefault: 'स्वयं-नियुक्त (डीफॉल्ट)',

    // Staff Dashboard
    staffCommandCenter: 'कर्मचारी नियंत्रण कक्ष',
    deptHeadDesk: 'विभाग प्रमुख व्यवस्थापन कक्ष',
    employeeDesk: 'माझ्याकडे सोपवलेल्या तक्रारी',
    repDesk: 'लोकप्रतिनिधी प्रभाग कक्ष',
    role: 'भूमिका',
    ward: 'प्रभाग',
    resetFilters: 'फिल्टर रीसेट करा',
    edit: 'संपादित करा',
    manageTicket: 'तक्रार व्यवस्थापन',
    updateStatus: 'स्थिती बदला',
    assignDeptEmployee: 'विभागीय कर्मचारी नियुक्त करा',
    noEmpAssigned: 'कोणताही कर्मचारी नियुक्त नाही',
    saveChanges: 'बदल जतन करा',
    saving: 'जतन करत आहे...',
    resolutionRemarksSummary: 'निवारण शेरा / कामाचा सारांश',
    resolutionPlaceholder: 'समस्या कशी सोडवली, कोणते काम केले, इतर तपशील येथे लिहा...',
    attachSolutionPhoto: 'निवारणाचा फोटो जोडा ("नंतरचा" फोटो)',

    // Complaint Detail Page
    backToDashboard: 'डॅशबोर्डवर परत जा',
    escalationNotice: 'व्यवस्थापन उच्च-स्तरीय सूचना',
    escalationDesc: 'ही तक्रार धोरण किंवा निकडीच्या आधारे उच्च स्तरावर वर्ग करण्यात आली आहे.',
    commentsUpdates: 'टिप्पण्या व अद्यतने',
    noCommentsYet: 'अद्याप कोणत्याही टिप्पण्या नाहीत. खाली संभाषण सुरू करा.',
    addResponseRemark: 'उत्तर / टिप्पणी जोडा',
    typeReplyHere: 'आपला प्रतिसाद येथे लिहा...',
    makeInternalNote: 'अंतर्गत नोंद (नागरिकांपासून लपवा)',
    postComment: 'टिप्पणी पोस्ट करा',
    posting: 'पोस्ट करत आहे...',
    staffInternalNote: 'कर्मचारी अंतर्गत नोंद',
    staffSolutionDesk: 'कर्मचारी निवारण व कार्य केंद्र',
    saveAttachSolution: 'निवारण जतन करा व फोटो जोडा',
    savingResolution: 'निवारण जतन करत आहे...',
    areaWardOfficials: 'प्रभाग व लोकप्रतिनिधी',
    ticketAssignment: 'तक्रार नियुक्ती तपशील',
    assignedDept: 'नियुक्त विभाग',
    assignedAgent: 'नियुक्त अधिकारी/एजंट',
    slaTargetResolution: 'निवारण मुदत लक्ष्य',
    slaBreached: 'मुदत संपली!',
    requestEscalation: 'उच्च स्तरावर पाठवा',
    auditHistoryTrail: 'ऑडिट इतिहास नोंद',

    // Auth
    welcomeBack: 'पुन्हा स्वागत आहे',
    signInSubtitle: 'आपल्या तक्रार व्यवस्थापन खात्यात प्रवेश करण्यासाठी लॉगिन करा.',
    emailLabel: 'ईमेल पत्ता',
    passwordLabel: 'पासवर्ड',
    loginBtn: 'खात्यात लॉगिन करा',
    loggingIn: 'लॉगिन होत आहे...',
    dontHaveAccount: 'खाते नाही?',
    registerNow: 'आता नोंदणी करा',
    createAccount: 'नवीन खाते उघडा',
    registerSubtitle: 'तक्रारी नोंदवण्यासाठी आणि ट्रॅक करण्यासाठी आमच्या नागरिक सेवा कक्षात सामील व्हा.',
    fullNameLabel: 'पूर्ण नाव',
    confirmPasswordLabel: 'पासवर्डची पुष्टी करा',
    registerBtn: 'नागरिक खाते तयार करा',
    registering: 'खाते तयार करत आहे...',
    alreadyHaveAccount: 'आधीच खाते आहे?',
    signInHere: 'येथे लॉगिन करा',

    // Footer
    footerRights: 'सर्व हक्क राखीव. सार्वजनिक तक्रार निवारण प्रणाली.',
    emergencyHelpline: 'नागरिक आपत्कालीन हेल्पलाइन: १८००-११-२२३३',

    // Roles Master
    role_admin: 'प्रणाली प्रशासक (Admin)',
    role_dept_head: 'विभाग प्रमुख (Dept Head)',
    role_employee: 'विभागीय कर्मचारी (Employee)',
    role_agent: 'सपोर्ट एजंट (Agent)',
    role_manager: 'ऑपरेशन्स मॅनेजर (Manager)',
    role_representative: 'प्रभाग लोकप्रतिनिधी (Representative)',
    role_customer: 'नागरिक / ग्राहक (Citizen)',
    rolesMaster: 'प्रणाली भूमिका व्यवस्थापन (Roles Master)',
    allRoles: 'सर्व प्रणाली भूमिका',
    totalUsersCount: 'एकूण वापरकर्ते',
    
    // User Management & Edits
    createUserTitle: 'नवीन कर्मचारी / वापरकर्ता तयार करा',
    editUserTitle: 'कर्मचारी / वापरकर्ता खाते संपादित करा',
    updateUserBtn: 'वापरकर्ता खाते अद्यतनित करा',
    updatingUser: 'अद्यतनित करत आहे...',
    leaveBlankPassword: 'सध्याचा पासवर्ड कायम ठेवण्यासाठी रिक्त ठेवा',
    newPasswordOptional: 'नवीन पासवर्ड (पर्यायी)',
    
    // Area / Location Edits
    createAreaTitle: 'नवीन प्रभाग / क्षेत्र तयार करा',
    editAreaTitle: 'प्रभाग / क्षेत्र संपादित करा',
    updateAreaBtn: 'प्रभाग माहिती जतन करा',
    areaName: 'प्रभाग / क्षेत्राचे नाव',
    areaCode: 'प्रभाग कोड',
    
    // Sublocation Edits
    subLocationsMaster: 'उपनगर / उप-ठिकाणे व्यवस्थापन',
    createSubAreaTitle: 'नवीन उप-ठिकाण जोडा',
    editSubAreaTitle: 'उप-ठिकाण संपादित करा',
    updateSubAreaBtn: 'उप-ठिकाण अद्यतनित करा',
    subAreaNameLabel: 'उप-ठिकाणाचे नाव',
    subAreaCodeLabel: 'उप-ठिकाण कोड (पर्यायी)',
    
    // Official / Representative Edits
    wardOfficialsTitle: 'प्रभाग लोकप्रतिनिधी',
    addOfficialTitle: 'नवीन लोकप्रतिनिधी जोडा',
    editOfficialTitle: 'लोकप्रतिनिधी माहिती संपादित करा',
    updateOfficialBtn: 'लोकप्रतिनिधी माहिती अद्यतनित करा',
    officialName: 'प्रतिनिधीचे पूर्ण नाव',
    officialDesignation: 'पद / हुद्दा',
    officialPhone: 'फोन / संपर्क क्रमांक',
    officialEmail: 'ईमेल पत्ता (पर्यायी)',
    
    // Department Edits
    createDepartmentTitle: 'नवीन विभाग जोडा',
    editDepartmentTitle: 'विभाग माहिती संपादित करा',
    updateDepartmentBtn: 'विभाग अद्यतनित करा',
    departmentName: 'विभागाचे नाव',
    departmentCode: 'विभाग कोड',
    
    // Common Actions
    actions: 'कृती',
    deleteConfirm: 'तुम्हाला नक्की ही नोंद हटवायची आहे का?'
  }
};

export default translations;
